import React from 'react';
import { Header } from '../components/Header';
import { Hero } from '../components/Hero';
import { Calculator } from '../components/Calculator';
import { TodayRates } from '../components/TodayRates';
import { HowItWorks } from '../components/HowItWorks';
import { WhyItMatters } from '../components/WhyItMatters';
import { Footer } from '../components/Footer';
import { WhatsAppButton } from '../components/WhatsAppButton';
export function AfriCardComparePage() {
  return <div className="min-h-screen bg-white" data-id="element-197">
      <Header data-id="element-198" />
      <main data-id="element-199">
        <Hero data-id="element-200" />
        <Calculator data-id="element-201" />
        <TodayRates data-id="element-202" />
        <HowItWorks data-id="element-203" />
        <WhyItMatters data-id="element-204" />
      </main>
      <Footer data-id="element-205" />
      <WhatsAppButton data-id="element-206" />
    </div>;
}